import Cookies from '../vendor/js.cookie.js'

// Rest for success message
$('.js-close-announcement').on('click', function() {
    var messageID = $(this).parent().data('message-id');
    if (!Cookies.get('botHideBanner'+messageID)) {
        Cookies.set('botHideBanner'+messageID, 'true', {});
    }
    $('.info-banner').remove();
});

// $(document).on("ready", function() {
//     if (Cookies.get('botHideBanner') !== 'true') {
//         $('.info-banner').removeClass('d-none');
//     }
// });